import { AUTH_ERROR, CHANGE_STEP } from "../types";

const initialState = {
  isAuthError: false,
  step: 0,
  currPage: null,
};

export const errorReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case AUTH_ERROR:
      return { ...state, isAuthError: payload };
    case CHANGE_STEP:
      return { ...state, step: payload };

    default:
      return state;
  }
};
